import styled from 'styled-components';
import NonRefundableSvg from './../assets/hotels/non-refundable.svg';

const NonRefundableIcon = styled(NonRefundableSvg as JSX.Element)`
  width: ${props => props.width};
  height: ${props => props.height};
  margin: ${props => props.margin};
  cursor: pointer;

  path:nth-of-type(2) {
    fill: ${props => props.fill};
  }

  transform: ${props => (props.transform ? props.transform : 'scale(1)')};
`;

export default NonRefundableIcon;
